import { render, staticRenderFns } from "./MarketSettings.vue?vue&type=template&id=3fdd78ba&scoped=true&"
import script from "./MarketSettings.vue?vue&type=script&lang=js&"
export * from "./MarketSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd78ba",
  null
  
)

export default component.exports